// src/components/ScrollToTopButton.js
import React, { useState, useEffect } from "react";
import { Fab } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { motion } from "framer-motion";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  // Show button when user scrolls down 200px
  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 200);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: visible ? 1 : 0 }}
      transition={{ duration: 0.5 }}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
      }}
    >
      <Fab
        sx={{ 
          backgroundColor: "var(--Primary-Color, #01345F)", 
          color: "#fff",
          backdropFilter: "blur(5px)",
          "&:hover": {
            backgroundColor: "color-mix(in srgb, var(--Primary-Color, #01345F) 90%, transparent)",
            backdropFilter: "blur(8px)",
          }
        }}
        size="medium"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </motion.div>
  );
};

export default ScrollToTopButton;
